<template>
  <div id="nutritional-data-content">
    <VTable id="nutritional-data-table" class="w-100">
      <tbody>
        <tr
          class="px-3 font-size-m"
          v-if="product.nutritional_data.ingredients"
        >
          <th class="w-25 pa-3 font-size-m align-top" scope="row">
            {{ translate('fe_app_pdp_attribute_ingredients') }}
          </th>
          <td id="nutritional-data-ingredients" class="p-2 font-size-m w-75">
            <span class="font-weight-normal"
              >{{ product.nutritional_data.ingredients }}
            </span>
            <span
              v-if="product.nutritional_data.contains_sulfide"
              class="font-weight-bold"
              >, {{ translate('pdp_attribute_sulphites') }}</span
            >
          </td>
        </tr>
        <tr class="px-3" v-if="hasNutritionalValues">
          <td colspan="2" class="text-center pa-3">
            {{ translate('fe_app_pdp_attribute_nutritional_value_headline') }}
          </td>
        </tr>
        <tr
          v-if="product.nutritional_data.kj && product.nutritional_data.kcal"
          class="px-3 font-size-m"
        >
          <th
            class="nutrient-row-th font-weight-bold pa-3 font-size-s text-uppercase"
            scope="row"
          >
            {{ translate('fe_app_pdp_attribute_item_energy') }}
          </th>
          <td style="width: 65%" class="pa-3 text-center">
            {{
              float(product.nutritional_data.kj) +
              ' kj (' +
              float(product.nutritional_data.kcal) +
              ' kcal)'
            }}
          </td>
        </tr>

        <NutrientRow
          v-for="nutrient in displayableNutrients"
          :key="nutrient.name"
          :name="nutrient.name"
          :value="nutrient.value"
          :unit="nutrient.unit"
          :threshold="nutrient.threshold"
        />

        <tr class="px-3 font-size-m" v-if="product.details.distributor">
          <td class="pa-3 text-center" colspan="2">
            {{ translate('fe_app_pdp_attribute_ingredients_disclaimer') }}
          </td>
        </tr>
      </tbody>
    </VTable>
  </div>
</template>

<script>
import NutrientRow from '@/components/pdp/atoms/NutrientRow.vue'
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'

export default {
  name: 'NutritionalData',
  components: { NutrientRow },
  computed: {
    ...mapState(usePdpStore, {
      product: 'getApiProduct',
      calculated: 'getCalculated'
    }),

    hasNutritionalValues() {
      return (
        this.product.nutritional_data.kj ||
        this.product.nutritional_data.carbohydrates ||
        this.product.nutritional_data.wine_sugar_grams
      )
    },

    displayableNutrients() {
      const nutrients = [
        {
          name: this.translate('fe_app_pdp_attribute_item_fat'),
          value: this.product.nutritional_data.fat,
          unit: 'g',
          threshold: 0.5
        },
        {
          name: this.translate(
            'fe_app_pdp_attribute_item_saturated_fatty_acids'
          ),
          value: this.product.nutritional_data.saturated_fatty_acids,
          unit: 'g',
          threshold: 0.1
        },
        {
          name: this.translate('fe_app_pdp_attribute_item_carbs'),
          value: this.product.nutritional_data.carbohydrates,
          unit: 'g',
          threshold: 0.5
        },
        {
          name: this.translate('fe_app_pdp_attribute_item_sugar'),
          value: this.product.nutritional_data.wine_sugar_grams,
          unit: 'g',
          threshold: 0.0
        },
        {
          name: this.translate('fe_app_pdp_attribute_item_protein'),
          value: this.product.nutritional_data.protein,
          unit: 'g',
          threshold: 0.5
        },
        {
          name: this.translate('fe_app_pdp_attribute_item_salt'),
          value: this.product.nutritional_data.salt,
          unit: 'g',
          threshold: 0.0125
        }
      ]

      return nutrients.filter((nutrient) => nutrient.value != null)
    }
  }
}
</script>

<style scoped>
#nutritional-data-ingredients {
  letter-spacing: 1.5px;
}

#nutritional-data-table tr:not(:last-child) {
  border-bottom: 1px solid rgb(var(--v-theme-ash-gray));
}

#nutritional-data-table tr:hover {
  background-color: rgb(var(--v-theme-creme));
}

.display-md-and-up #nutritional-data-table td:first-child,
th:first-child {
  padding-left: 1rem;
}

#nutritional-data-table td:first-child,
th:first-child {
  font-weight: 700;
  letter-spacing: 1px;
}

#nutritional-data-table td:first-child:not(:last-child),
th:first-child:not(:last-child) {
  color: rgb(var(--v-theme-gray));
  text-transform: uppercase;
  font-size: var(--s-font-size);
}
</style>
